import Swal from 'sweetalert2';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {Trash, Pencil, PencilFill} from 'react-bootstrap-icons';

function ReferralPartnerRow({ partner }) {

  const [referralName, setNewReferralName] = useState('');
  const [referralPhone, setNewReferralPhone] = useState('');
  const [referralCode, setNewReferralCode] = useState('');
  const [referralNameEdit, setNewReferralNameEdit] = useState(partner.name);
  const [referralPhoneEdit, setNewReferralPhoneEdit] = useState(partner.phone);
  const [referralCodeEdit, setNewReferralCodeEdit] = useState(partner.code);
  const [edit, setEdit] = useState(false);

  const dispatch = useDispatch();

  const handleEdit = () => {
    setEdit(true);
  }
  const handleExit = () => {
    setEdit(false);
  }
  function handleEditSubmit() {
    event.preventDefault();
    handleExit();
    dispatch({
      type: 'UPDATE_REFERRAL_PARTNER', payload: {
        id: partner.id,
        name: referralNameEdit,
        phone: referralPhoneEdit,
        code: referralCodeEdit,
      }
    });
    dispatch({ type: 'FETCH_REFERRALS' });
  }

  const deleteReferralPartner = (id) => {
    console.log(`Partner id is: ${partner.id}`);
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      console.log('Made it to step 2!');
      if (result.value) {
        dispatch({ type: 'DELETE_REFERRAL_PARTNER', payload: id })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Referral partner not deleted'
        )
      }
    })
    dispatch({ type: 'FETCH_REFERRALS' });
  }

  function addDashes(phone) {
    return "(" + phone.slice(0, 3) + ") " + phone.slice(3, 6) + "-" + phone.slice(6);
  }

  return (
    <>
      <tr key={partner.id}>
        {edit == false ?
          <td scope="row" className="text-center">{partner.name}</td> :
          <td className="text-center"><input type="text" value={referralNameEdit} onChange={event => setNewReferralNameEdit(event.target.value)} ></input></td>
        }
        {edit == false ?
          <td scope="row" className="text-center">{addDashes(partner.phone)}</td> :
          <td className="text-center"><input type="number" value={referralPhoneEdit} onChange={event => setNewReferralPhoneEdit(event.target.value)}></input></td>
        }
        {edit == false ?
          <td scope="row" className="text-center">{partner.code}</td> :
          <td className="text-center"><input type="code" value={referralCodeEdit} onChange={event => setNewReferralCodeEdit(event.target.value)}></input></td>
        }
        <td scope="row" className="text-center">
          {edit === false ? 
          <Pencil className="mr-2" type="button" size={30} onClick={handleEdit}/> :
          <PencilFill className="mr-2" type="button" size={30} onClick={handleEditSubmit}/>
          }
          <Trash className="ml-2" type="button" size={30} color="red" onClick={() => deleteReferralPartner(partner.id)} />
        </td>

      </tr>
    </>
  )
}

export default ReferralPartnerRow;